module.exports = __webpack_public_path__ + "static/media/16x20no2.ffa14032.jpg";